import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingClassTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingClassType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingClassTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingClassTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingClassTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingClassType> | null) => {
      onChange({ action: 'setBuildingClassType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBuildingClassTypeChange} />
    </AdvancedFilterRow>
  );
};
